var map = {
	"./Animations/Creatures/bot1.png": 23764,
	"./Animations/Creatures/bot1_select.png": 44609,
	"./Animations/Creatures/bot2.png": 46223,
	"./Animations/Creatures/bot2_select.png": 71440,
	"./Animations/Creatures/bot3.png": 61126,
	"./Animations/Creatures/bot3_select.png": 35003,
	"./Animations/Creatures/bot4.png": 66105,
	"./Animations/Creatures/bot4_select.png": 11402,
	"./Animations/Creatures/bot5.png": 34000,
	"./Animations/Creatures/bot5_select.png": 48589,
	"./Animations/Creatures/bot6.png": 99403,
	"./Animations/Creatures/bot6_select.png": 72636,
	"./Animations/Creatures/bot7.png": 52098,
	"./Animations/Creatures/bot7_select.png": 55207,
	"./Animations/Creatures/bot8.png": 52965,
	"./Animations/Creatures/bot8_select.png": 25270,
	"./Animations/Creatures/idle_robot_select.png": 78240,
	"./Animations/Creatures/stop_robot.png": 34213,
	"./Animations/Creatures/stop_robot_select.png": 48438,
	"./Animations/NewProgram.png": 54731,
	"./Animations/Programs/Icons/Abracadabra.png": 87908,
	"./Animations/Programs/Icons/Aespa.png": 31300,
	"./Animations/Programs/Icons/AstroCharge.png": 26769,
	"./Animations/Programs/Icons/AstroMine.png": 87548,
	"./Animations/Programs/Icons/BioCast.png": 27795,
	"./Animations/Programs/Icons/BioFusion.png": 54158,
	"./Animations/Programs/Icons/BioGen.png": 9050,
	"./Animations/Programs/Icons/BioHarvest.png": 12551,
	"./Animations/Programs/Icons/BioSurge.png": 80794,
	"./Animations/Programs/Icons/BioSynthesis.png": 63354,
	"./Animations/Programs/Icons/CerebraSpark.png": 88509,
	"./Animations/Programs/Icons/CogniFy.png": 26281,
	"./Animations/Programs/Icons/CogniMelt.png": 90992,
	"./Animations/Programs/Icons/CrysTara.png": 73055,
	"./Animations/Programs/Icons/CrystaBloom.png": 9719,
	"./Animations/Programs/Icons/CyberPulse.png": 85948,
	"./Animations/Programs/Icons/EnerFusion.png": 382,
	"./Animations/Programs/Icons/EnerGate.png": 89035,
	"./Animations/Programs/Icons/EnerGex.png": 27052,
	"./Animations/Programs/Icons/EnerPlex.png": 32529,
	"./Animations/Programs/Icons/EtherForge.png": 46755,
	"./Animations/Programs/Icons/EtherPulse.png": 73265,
	"./Animations/Programs/Icons/EtherWeave.png": 20188,
	"./Animations/Programs/Icons/EvolviFy.png": 4966,
	"./Animations/Programs/Icons/FoamTap.png": 48638,
	"./Animations/Programs/Icons/FortiFyx.png": 67879,
	"./Animations/Programs/Icons/FortiGen.png": 49344,
	"./Animations/Programs/Icons/Fortivest.png": 80230,
	"./Animations/Programs/Icons/IlluGen.png": 7284,
	"./Animations/Programs/Icons/MegaBoost.png": 25819,
	"./Animations/Programs/Icons/NanoWeave.png": 29892,
	"./Animations/Programs/Icons/NeuroCharge.png": 52265,
	"./Animations/Programs/Icons/NeuroForge.png": 35776,
	"./Animations/Programs/Icons/NexiMine.png": 36161,
	"./Animations/Programs/Icons/NexroVest.png": 77982,
	"./Animations/Programs/Icons/NexuMax.png": 10052,
	"./Animations/Programs/Icons/NexusField.png": 57357,
	"./Animations/Programs/Icons/NovaBurst.png": 68040,
	"./Animations/Programs/Icons/NovaFlux.png": 72981,
	"./Animations/Programs/Icons/PlasmaCharge.png": 51608,
	"./Animations/Programs/Icons/PlasmaForge.png": 18579,
	"./Animations/Programs/Icons/PlasmaShift.png": 74526,
	"./Animations/Programs/Icons/QuantaForge.png": 45187,
	"./Animations/Programs/Icons/QuantumCore.png": 20898,
	"./Animations/Programs/Icons/QuantumFrost.png": 99713,
	"./Animations/Programs/Icons/QuantumLeap.png": 11433,
	"./Animations/Programs/Icons/QuantumScribe.png": 72021,
	"./Animations/Programs/Icons/QuantumSurge.png": 1877,
	"./Animations/Programs/Icons/QuiFoam.png": 55376,
	"./Animations/Programs/Icons/ResoNex.png": 6886,
	"./Animations/Programs/Icons/SpicenRich.png": 69096,
	"./Animations/Programs/Icons/StarForge.png": 20453,
	"./Animations/Programs/Icons/StarLight.png": 18092,
	"./Animations/Programs/Icons/StarlightForge.png": 93443,
	"./Animations/Programs/Icons/StellarCharge.png": 99543,
	"./Animations/Programs/Icons/SuperNova.png": 23591,
	"./Animations/Programs/Icons/SwiftForge.png": 87972,
	"./Animations/Programs/Icons/SynTitan.png": 83422,
	"./Animations/Programs/Icons/TTgenesis.png": 95894,
	"./Animations/Programs/Icons/TitanBloom.png": 54269,
	"./Animations/Programs/Icons/TitaniumBoost.png": 83366,
	"./Animations/Programs/Icons/XenoBloom.png": 12505,
	"./Animations/Programs/Icons/XenoFloral.png": 33416,
	"./Animations/Programs/SpriteSheets/Abracadabra.png": 96237,
	"./Animations/Programs/SpriteSheets/Aespa.png": 78405,
	"./Animations/Programs/SpriteSheets/AstroCharge.png": 81300,
	"./Animations/Programs/SpriteSheets/AstroMine.png": 65253,
	"./Animations/Programs/SpriteSheets/BioCast.png": 60306,
	"./Animations/Programs/SpriteSheets/BioFusion.png": 13307,
	"./Animations/Programs/SpriteSheets/BioGen.png": 7361,
	"./Animations/Programs/SpriteSheets/BioHarvest.png": 8172,
	"./Animations/Programs/SpriteSheets/BioSurge.png": 93797,
	"./Animations/Programs/SpriteSheets/BioSynthesis.png": 54681,
	"./Animations/Programs/SpriteSheets/CerebraSpark.png": 83086,
	"./Animations/Programs/SpriteSheets/CogniFy.png": 55012,
	"./Animations/Programs/SpriteSheets/CogniMelt.png": 94925,
	"./Animations/Programs/SpriteSheets/CrysTara.png": 81812,
	"./Animations/Programs/SpriteSheets/CrystaBloom.png": 27402,
	"./Animations/Programs/SpriteSheets/CyberPulse.png": 63567,
	"./Animations/Programs/SpriteSheets/EnerFusion.png": 78393,
	"./Animations/Programs/SpriteSheets/EnerGate.png": 94564,
	"./Animations/Programs/SpriteSheets/EnerGex.png": 40837,
	"./Animations/Programs/SpriteSheets/EnerPlex.png": 77362,
	"./Animations/Programs/SpriteSheets/EtherForge.png": 66356,
	"./Animations/Programs/SpriteSheets/EtherPulse.png": 77010,
	"./Animations/Programs/SpriteSheets/EtherWeave.png": 1951,
	"./Animations/Programs/SpriteSheets/EvolviFy.png": 68121,
	"./Animations/Programs/SpriteSheets/FoamTap.png": 23835,
	"./Animations/Programs/SpriteSheets/FortiFyx.png": 77252,
	"./Animations/Programs/SpriteSheets/FortiGen.png": 44611,
	"./Animations/Programs/SpriteSheets/Fortivest.png": 40511,
	"./Animations/Programs/SpriteSheets/IlluGen.png": 84185,
	"./Animations/Programs/SpriteSheets/MegaBoost.png": 91662,
	"./Animations/Programs/SpriteSheets/NanoWeave.png": 52405,
	"./Animations/Programs/SpriteSheets/NeuroCharge.png": 86288,
	"./Animations/Programs/SpriteSheets/NeuroForge.png": 53819,
	"./Animations/Programs/SpriteSheets/NexiMine.png": 77586,
	"./Animations/Programs/SpriteSheets/NexroVest.png": 68671,
	"./Animations/Programs/SpriteSheets/NexuMax.png": 11533,
	"./Animations/Programs/SpriteSheets/NexusField.png": 38334,
	"./Animations/Programs/SpriteSheets/NovaBurst.png": 41717,
	"./Animations/Programs/SpriteSheets/NovaFlux.png": 40522,
	"./Animations/Programs/SpriteSheets/PlasmaCharge.png": 81707,
	"./Animations/Programs/SpriteSheets/PlasmaForge.png": 35930,
	"./Animations/Programs/SpriteSheets/PlasmaShift.png": 59347,
	"./Animations/Programs/SpriteSheets/QuantaForge.png": 56018,
	"./Animations/Programs/SpriteSheets/QuantumCore.png": 15343,
	"./Animations/Programs/SpriteSheets/QuantumFrost.png": 12042,
	"./Animations/Programs/SpriteSheets/QuantumLeap.png": 93204,
	"./Animations/Programs/SpriteSheets/QuantumScribe.png": 93604,
	"./Animations/Programs/SpriteSheets/QuantumSurge.png": 11546,
	"./Animations/Programs/SpriteSheets/QuiFoam.png": 34025,
	"./Animations/Programs/SpriteSheets/ResoNex.png": 74635,
	"./Animations/Programs/SpriteSheets/SpicenRich.png": 34671,
	"./Animations/Programs/SpriteSheets/StarForge.png": 5948,
	"./Animations/Programs/SpriteSheets/StarLight.png": 75393,
	"./Animations/Programs/SpriteSheets/StarlightForge.png": 41480,
	"./Animations/Programs/SpriteSheets/StellarCharge.png": 46506,
	"./Animations/Programs/SpriteSheets/SuperNova.png": 77514,
	"./Animations/Programs/SpriteSheets/SwiftForge.png": 52083,
	"./Animations/Programs/SpriteSheets/SynTitan.png": 75045,
	"./Animations/Programs/SpriteSheets/TTgenesis.png": 46039,
	"./Animations/Programs/SpriteSheets/TitanBloom.png": 4478,
	"./Animations/Programs/SpriteSheets/TitaniumBoost.png": 67947,
	"./Animations/Programs/SpriteSheets/XenoBloom.png": 53840,
	"./Animations/Programs/SpriteSheets/XenoFloral.png": 8535,
	"./Animations/Rockets/rocket1.png": 89470,
	"./Animations/Rockets/rocket2.png": 26197,
	"./Animations/Rockets/rocket3.png": 14572,
	"./Animations/Rockets/rocket4.png": 63971,
	"./Animations/Rockets/rocket5.png": 74138,
	"./Animations/TitaniumScore.png": 8208,
	"./Animations/Unlock.png": 54473,
	"./Animations/Wave.png": 39890,
	"./Animations/tutorial_creature.png": 36335,
	"./Animations/tutorial_program.png": 58838,
	"./Buttons/CollectInterest/collect.png": 69860,
	"./Buttons/CollectInterest/collect_click.png": 77193,
	"./Buttons/CollectInterest/collect_hv.png": 27575,
	"./Buttons/CollectInterest/collect_idle.png": 1507,
	"./Buttons/ConfirmButton/confirm.png": 3502,
	"./Buttons/ConfirmButton/confirm_click.png": 57155,
	"./Buttons/ConfirmButton/confirm_hv.png": 6821,
	"./Buttons/ConfirmButton/confirm_idle.png": 51965,
	"./Buttons/CreatureConfirm/creature_confirm.png": 50301,
	"./Buttons/CreatureConfirm/creature_confirm_click.png": 95656,
	"./Buttons/CreatureConfirm/creature_confirm_hv.png": 94600,
	"./Buttons/CreatureNewPlanet1/creature_new.png": 10574,
	"./Buttons/CreatureNewPlanet1/creature_new_click.png": 27331,
	"./Buttons/CreatureNewPlanet1/creature_new_hv.png": 36357,
	"./Buttons/CreatureNewPlanet2/creature_new.png": 21095,
	"./Buttons/CreatureNewPlanet2/creature_new_click.png": 97346,
	"./Buttons/CreatureNewPlanet2/creature_new_hv.png": 93142,
	"./Buttons/CreatureReboot/creature_reboot.png": 36463,
	"./Buttons/CreatureReboot/creature_reboot_click.png": 84394,
	"./Buttons/CreatureReboot/creature_reboot_hv.png": 6222,
	"./Buttons/Deposit/deposit.png": 3130,
	"./Buttons/Deposit/deposit_click.png": 5871,
	"./Buttons/Deposit/deposit_hv.png": 55241,
	"./Buttons/ErrorConfirmButton/error_confirm.png": 55603,
	"./Buttons/ErrorConfirmButton/error_confirm_click.png": 71534,
	"./Buttons/ErrorConfirmButton/error_confirm_hv.png": 87546,
	"./Buttons/ErrorConfirmButton/error_confirm_idle.png": 13290,
	"./Buttons/GuidePlayButton/guide_play.png": 83671,
	"./Buttons/GuidePlayButton/guide_play_click.png": 69202,
	"./Buttons/GuidePlayButton/guide_play_hv.png": 68710,
	"./Buttons/GuidePlayButton/guide_play_idle.png": 55078,
	"./Buttons/Help/help.png": 47810,
	"./Buttons/Help/help_click.png": 6647,
	"./Buttons/Help/help_hv.png": 78241,
	"./Buttons/HorizontalNextPage/next.png": 5605,
	"./Buttons/HorizontalNextPage/next_click.png": 79216,
	"./Buttons/HorizontalNextPage/next_hover.png": 42838,
	"./Buttons/HorizontalPrevPage/back.png": 96051,
	"./Buttons/HorizontalPrevPage/back_click.png": 31118,
	"./Buttons/HorizontalPrevPage/back_hover.png": 53780,
	"./Buttons/HorizontalPrevPage/back_idle.png": 1098,
	"./Buttons/Market/market.png": 13620,
	"./Buttons/Market/market_click.png": 84281,
	"./Buttons/Market/market_hv.png": 28871,
	"./Buttons/MarketConfirmButton/market_confirm.png": 91989,
	"./Buttons/MarketConfirmButton/market_confirm_click.png": 53408,
	"./Buttons/MarketConfirmButton/market_confirm_hv.png": 53104,
	"./Buttons/MarketConfirmButton/market_confirm_idle.png": 70964,
	"./Buttons/MarketProgramBidButton/market_program_bid.png": 68770,
	"./Buttons/MarketProgramBidButton/market_program_bid_click.png": 51703,
	"./Buttons/MarketProgramBidButton/market_program_bid_hv.png": 16449,
	"./Buttons/MarketProgramBidButton/market_program_bid_idle.png": 13625,
	"./Buttons/MarketProgramListButton/market_program_list.png": 29538,
	"./Buttons/MarketProgramListButton/market_program_list_click.png": 84439,
	"./Buttons/MarketProgramListButton/market_program_list_hv.png": 78209,
	"./Buttons/MarketProgramListButton/market_program_list_idle.png": 5241,
	"./Buttons/MarketProgramSellButton/market_program_sell.png": 30962,
	"./Buttons/MarketProgramSellButton/market_program_sell_click.png": 46919,
	"./Buttons/MarketProgramSellButton/market_program_sell_hv.png": 1137,
	"./Buttons/MarketProgramSellButton/market_program_sell_idle.png": 36553,
	"./Buttons/MarketRefreshButton/market_refresh.png": 18799,
	"./Buttons/MarketRefreshButton/market_refresh_click.png": 27658,
	"./Buttons/MarketRefreshButton/market_refresh_hv.png": 13902,
	"./Buttons/MarketRefreshButton/market_refresh_idle.png": 97470,
	"./Buttons/MarketScene/market_scene.png": 40449,
	"./Buttons/MarketScene/market_scene_click.png": 91004,
	"./Buttons/MarketScene/market_scene_hv.png": 73412,
	"./Buttons/MarketTabButton/market_tab.png": 27243,
	"./Buttons/MarketTabButton/market_tab_click.png": 19878,
	"./Buttons/MarketTabButton/market_tab_hv.png": 58626,
	"./Buttons/MarketTabButton/market_tab_idle.png": 26178,
	"./Buttons/New/new.png": 73854,
	"./Buttons/New/new_click.png": 71315,
	"./Buttons/New/new_hover.png": 73589,
	"./Buttons/NewProgramAnimationCollectButton/new_program_animation_collect.png": 37719,
	"./Buttons/NewProgramAnimationCollectButton/new_program_animation_collect_click.png": 96722,
	"./Buttons/NewProgramAnimationCollectButton/new_program_animation_collect_hv.png": 76486,
	"./Buttons/NewProgramAnimationCollectButton/new_program_animation_collect_idle.png": 23910,
	"./Buttons/NewProgramButton/new_program.png": 53079,
	"./Buttons/NewProgramButton/new_program_click.png": 83730,
	"./Buttons/NewProgramButton/new_program_hv.png": 34534,
	"./Buttons/NewProgramButton/new_program_idle.png": 76198,
	"./Buttons/NextPage/down.png": 51422,
	"./Buttons/NextPage/down_click.png": 73043,
	"./Buttons/NextPage/down_hv.png": 51842,
	"./Buttons/Ok/ok.png": 14700,
	"./Buttons/Ok/ok_click.png": 11185,
	"./Buttons/Ok/ok_hv.png": 63823,
	"./Buttons/Planet1/planet1.png": 18766,
	"./Buttons/Planet1/planet1_click.png": 90851,
	"./Buttons/Planet1/planet1_hv.png": 90949,
	"./Buttons/Planet1/planet1_idle.png": 86493,
	"./Buttons/Planet2/planet2.png": 88038,
	"./Buttons/Planet2/planet2_click.png": 859,
	"./Buttons/Planet2/planet2_hv.png": 80045,
	"./Buttons/Planet2/planet2_idle.png": 42453,
	"./Buttons/Planet3/planet3.png": 7562,
	"./Buttons/Planet3/planet3_click.png": 65535,
	"./Buttons/Planet3/planet3_hv.png": 48921,
	"./Buttons/Planet3/planet3_idle.png": 81377,
	"./Buttons/PlanetScene/planet_scene.png": 43529,
	"./Buttons/PlanetScene/planet_scene_click.png": 41092,
	"./Buttons/PlanetScene/planet_scene_hv.png": 2652,
	"./Buttons/PrevPage/up.png": 67669,
	"./Buttons/PrevPage/up_click.png": 6720,
	"./Buttons/PrevPage/up_hv.png": 64912,
	"./Buttons/Program/program.png": 67738,
	"./Buttons/Program/program_click.png": 65103,
	"./Buttons/Program/program_disabled.png": 56415,
	"./Buttons/Program/program_hv.png": 84777,
	"./Buttons/RedeemDisplay/redeem_display.png": 77129,
	"./Buttons/RedeemDisplay/redeem_display_click.png": 72292,
	"./Buttons/RedeemDisplay/redeem_display_hv.png": 4924,
	"./Buttons/RedeemDisplay/redeem_display_idle.png": 25152,
	"./Buttons/RedeemScene/redeem_scene.png": 38449,
	"./Buttons/RedeemScene/redeem_scene_click.png": 78860,
	"./Buttons/RedeemScene/redeem_scene_hv.png": 91284,
	"./Buttons/RocketSwitchButton/rocket_switch_off.png": 42703,
	"./Buttons/RocketSwitchButton/rocket_switch_off_hv.png": 20174,
	"./Buttons/RocketSwitchButton/rocket_switch_on.png": 94277,
	"./Buttons/RocketSwitchButton/rocket_switch_on_hv.png": 17440,
	"./Buttons/Upgrade/upgrade.png": 98446,
	"./Buttons/Upgrade/upgrade_click.png": 70339,
	"./Buttons/Upgrade/upgrade_hv.png": 29925,
	"./Buttons/Upgrade/upgrade_idle.png": 22973,
	"./Buttons/UpgradeConfirm/upgrade_confirm.png": 79771,
	"./Buttons/UpgradeConfirm/upgrade_confirm_click.png": 12534,
	"./Buttons/UpgradeConfirm/upgrade_confirm_hv.png": 20178,
	"./Buttons/UpgradeConfirm/upgrade_confirm_idle.png": 5746,
	"./Buttons/UpgradeEfficiency/efficiency_hover.png": 27853,
	"./Buttons/UpgradeEfficiency/efficiency_normal.png": 3930,
	"./Buttons/UpgradeEfficiency/efficiency_select.png": 41915,
	"./Buttons/UpgradeProductivity/productivity_hover.png": 21019,
	"./Buttons/UpgradeProductivity/productivity_normal.png": 92212,
	"./Buttons/UpgradeProductivity/productivity_select.png": 53529,
	"./Buttons/UpgradeSpeed/speed_hover.png": 12069,
	"./Buttons/UpgradeSpeed/speed_normal.png": 41954,
	"./Buttons/UpgradeSpeed/speed_select.png": 73235,
	"./Buttons/WelcomeConnectWalletButton/welcome_connect_wallet.png": 4630,
	"./Buttons/WelcomeConnectWalletButton/welcome_connect_wallet_click.png": 64555,
	"./Buttons/WelcomeConnectWalletButton/welcome_connect_wallet_hv.png": 62397,
	"./Buttons/WelcomeConnectWalletButton/welcome_connect_wallet_idle.png": 25445,
	"./Buttons/WelcomePlayButton/welcome_play.png": 14235,
	"./Buttons/WelcomePlayButton/welcome_play_click.png": 67126,
	"./Buttons/WelcomePlayButton/welcome_play_hv.png": 47154,
	"./Buttons/WelcomePlayButton/welcome_play_idle.png": 16466,
	"./Buttons/Withdraw/withdraw.png": 59992,
	"./Buttons/Withdraw/withdraw_click.png": 74797,
	"./Buttons/Withdraw/withdraw_hv.png": 23075,
	"./CreatureBots/robot1.png": 2172,
	"./CreatureBots/robot2.png": 9751,
	"./CreatureBots/robot3.png": 26606,
	"./CreatureBots/robot4.png": 25089,
	"./Guides/step1.png": 80964,
	"./Guides/step2.png": 66239,
	"./Guides/step3.png": 12438,
	"./Guides/step4.png": 62409,
	"./Guides/step5.png": 38208,
	"./Icons/AlienFloral.png": 61277,
	"./Icons/AlienFloralDisabled.png": 76325,
	"./Icons/Biomass.png": 71424,
	"./Icons/BiomassDisabled.png": 56224,
	"./Icons/Crystal.png": 10996,
	"./Icons/CrystalDisabled.png": 77364,
	"./Icons/InterstellarMineral.png": 81567,
	"./Icons/InterstellarMineralDisabled.png": 79863,
	"./Icons/Necrodermis.png": 15819,
	"./Icons/NecrodermisDisabled.png": 14691,
	"./Icons/QuantumFoam.png": 23186,
	"./Icons/QuantumFoamDisabled.png": 48546,
	"./Icons/SpiceMelange.png": 5557,
	"./Icons/SpiceMelangeDisabled.png": 4701,
	"./Icons/Titanium.png": 67293,
	"./Icons/TitaniumDisabled.png": 75685,
	"./Icons/efficiency.png": 81927,
	"./Icons/level.png": 43496,
	"./Icons/productivity.png": 57704,
	"./Icons/speed.png": 47039,
	"./backgrounds/account_info.png": 83403,
	"./backgrounds/background_back.png": 8293,
	"./backgrounds/background_front.png": 22347,
	"./backgrounds/bg.png": 23990,
	"./backgrounds/bg_1.png": 25986,
	"./backgrounds/bg_spin.png": 8195,
	"./backgrounds/bottom_bar.png": 68396,
	"./backgrounds/circle.png": 8579,
	"./backgrounds/creature_frame.png": 18562,
	"./backgrounds/creature_frame_progress_mask.png": 33939,
	"./backgrounds/creature_frame_stop_mask.png": 14948,
	"./backgrounds/empty_program_frame.png": 22467,
	"./backgrounds/energy_icon.png": 53067,
	"./backgrounds/frame.png": 77336,
	"./backgrounds/guide_frame.png": 59821,
	"./backgrounds/hover_frame.png": 5067,
	"./backgrounds/info_frame.png": 97265,
	"./backgrounds/left_bar_deco.png": 9668,
	"./backgrounds/left_bottom.png": 30308,
	"./backgrounds/left_corner_bar.png": 38756,
	"./backgrounds/left_mid.png": 46415,
	"./backgrounds/left_top.png": 71112,
	"./backgrounds/list_by_you_icon.png": 88327,
	"./backgrounds/listed_program_frame.png": 94587,
	"./backgrounds/loading.png": 29451,
	"./backgrounds/main_program_frame.png": 4031,
	"./backgrounds/market_card_frame.png": 97960,
	"./backgrounds/market_frame.png": 83005,
	"./backgrounds/market_money_background.png": 30563,
	"./backgrounds/menu_bg.png": 44494,
	"./backgrounds/new_program_normal.png": 23688,
	"./backgrounds/number_display.png": 3087,
	"./backgrounds/planet.png": 3321,
	"./backgrounds/planet2.png": 30351,
	"./backgrounds/planet_frame.png": 99995,
	"./backgrounds/player_energy.png": 37181,
	"./backgrounds/player_info_background.png": 58402,
	"./backgrounds/player_info_level_frame.png": 56236,
	"./backgrounds/player_lv.png": 18687,
	"./backgrounds/player_xp.png": 54701,
	"./backgrounds/program_select.png": 18044,
	"./backgrounds/redeem_frame.png": 28097,
	"./backgrounds/robot_select.png": 49144,
	"./backgrounds/selecting_frame.png": 63685,
	"./backgrounds/sponsor logo.png": 22992,
	"./backgrounds/sponsor_frame.png": 43263,
	"./backgrounds/summary_resource_frame.png": 96386,
	"./backgrounds/tab.png": 70098,
	"./backgrounds/tab_select.png": 2263,
	"./backgrounds/titan_frame.png": 96019,
	"./backgrounds/top_bar.png": 2948,
	"./backgrounds/top_bg.png": 43450,
	"./backgrounds/top_left.png": 69544,
	"./backgrounds/top_mid.png": 83477,
	"./backgrounds/top_right.png": 49213,
	"./backgrounds/tutorial_frame.png": 38411,
	"./backgrounds/ufo.png": 37563,
	"./backgrounds/upgrade_frame.png": 87745,
	"./backgrounds/withdraw_amount_background.png": 72855,
	"./backgrounds/withdraw_frame.png": 2691,
	"./button/blue_button/left.png": 36803,
	"./button/blue_button/left_click.png": 14686,
	"./button/blue_button/left_hv.png": 60202,
	"./button/blue_button/left_idle.png": 9754,
	"./button/blue_button/mid.png": 29052,
	"./button/blue_button/mid_click.png": 18241,
	"./button/blue_button/mid_hv.png": 88863,
	"./button/blue_button/mid_idle.png": 40763,
	"./button/blue_button/right.png": 29580,
	"./button/blue_button/right_click.png": 91697,
	"./button/blue_button/right_hv.png": 49519,
	"./button/blue_button/right_idle.png": 65739,
	"./button/orange_button/left.png": 71917,
	"./button/orange_button/left_click.png": 72728,
	"./button/orange_button/left_hv.png": 35672,
	"./button/orange_button/left_idle.png": 15628,
	"./button/orange_button/mid.png": 73038,
	"./button/orange_button/mid_click.png": 12739,
	"./button/orange_button/mid_hv.png": 33893,
	"./button/orange_button/mid_idle.png": 68029,
	"./button/orange_button/right.png": 49230,
	"./button/orange_button/right_click.png": 56899,
	"./button/orange_button/right_hv.png": 8837,
	"./button/orange_button/right_idle.png": 99549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34436;